/* eslint-disable react-hooks/exhaustive-deps */
import { useState } from 'react';
import { Modal } from 'semantic-ui-react';
import ViewLinkedActivityForm from '../forms/viewLinkedActivityForm';
import { get } from '../../../../../../utils/lodash';

export default function ViewLinkedActivity(props) {
  const { activity, trigger } = props;
  const [viewModal, setViewModal] = useState(false);

  const handelViewToggle = () => {
    setViewModal(!viewModal);
  };

  const parentActivityPlanTypeId = get(
    activity,
    'parentActivity.activityPlanTypeId',
    null
  );
  const activityPlanTypeId = get(activity, 'activityPlanTypeId', null);

  return (
    <Modal
      trigger={<div onClick={() => handelViewToggle()}>{trigger}</div>}
      size="small"
      open={viewModal}
    >
      <Modal.Header className="goal-confirm-modal-header">
        <div className="modal-heading"> {activity.name} </div>
        <div className="slim-close-icon" onClick={() => handelViewToggle()}>
          &times;
        </div>
      </Modal.Header>
      <Modal.Content>
        <ViewLinkedActivityForm
          activityPlanTypeId={activityPlanTypeId}
          parentActivityPlanTypeId={parentActivityPlanTypeId}
          toggle={handelViewToggle}
          {...props}
        />
      </Modal.Content>
    </Modal>
  );
}
